export const ROUTES = {
	ACCOUNT: {
		ROOT: "/account",
		PROFILE: "/account/profile",
		ADDRESS: "/account/address",
		PAYMENT: "/account/payment",
		ORDER: "/account/order",
		PURCHASE_LISTS: "/account/purchase-lists",
		MATERIAL: "/account/material",
		GALLERY: "/account/gallery"
	}
} as const;
